'use strict';

exports.__esModule = true;
exports.page = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pageActions = require('../actions/page-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  searchOnLoad: false,
  loadingResults: true,

  pageLoaded: false,

  searchBarHolderHeight: 0,
  insurersDropdownElem: null
};

var page = exports.page = function page(state, action) {
  switch (action.type) {
    case _pageActions.GOOGLE_MAP_LOADED:
      return (0, _assign2.default)({}, state, { googleMapLoaded: true });
    case _pageActions.PAGE_LOADED:
      return (0, _assign2.default)({}, state, { pageLoaded: true });
    case _pageActions.SEARCH_BAR_HOLDER_HEIGHT_UPDATE:
    case _pageActions.INSURERS_DROPDOWN_ELEM_UPDATE:
    case _pageActions.INSURERS_SEARCH_ITEM_ELEM_UPDATE:
      return (0, _extends3.default)({}, state, action.payload);
    default:
      return state || INITIAL_STATE;
  }
};


// WEBPACK FOOTER //
// ./components/search-page/lib/reducers/page-reducers.js